import React from 'react';
import Team from './team.js';

const TeamList = (props) => {
  const teams = Object.keys(props).map((team) => {
    return (
      <Team {...props[team]} key={props[team].teamName} />
    )
  });

  return (
    <div className="teamlist">
      {teams}
    </div>
  );
};

export default TeamList;


// WEBPACK FOOTER //
// ./src/components/teamlist.js